<div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-around stretch" fxFlex>
  <div fxFlex="66" fxLayout="column" fxLayoutAlign="space-around stretch" data-qa="messages">
    @if (hasInvalidPlanwerte) {
      <span>Es liegen ungültige Planwerte vor. Über den Button können Sie diese einsehen.
      Die Ursache sind Änderungen an den Istdaten der Erzeugungsanlage im Nachgang zur Planwerterfassung.</span>
    }
    @if (!hasInvalidPlanwerte) {
      <span>Ihre Planwerte sind in Ordnung.</span>
      <span>Es ist keine Aktivität notwendig.</span>
    }
  </div>
  <div fxFlex="33" fxLayoutAlign="center center" data-qa="link">
    <a [matButton]="hasInvalidPlanwerte ? 'filled' : 'outlined'"
      [routerLink]="routerLink"
      [queryParams]="queryParams">
      Planwerte
    </a>
  </div>
</div>
